var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconTram = function SvgIconTram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 19.92V9.8c0-3.36-3.122-4.078-7.2-4.2l.919-1.8H20.4V2h-12v1.8h5.719L13.2 5.6C9.44 5.722 6 6.481 6 9.8v10.12c0 1.72 1.44 3.202 3.122 3.558L7.2 25.4v.6h2.681l2.4-2.4H16.8l2.4 2.4h2.4v-.6l-1.8-1.8h-.08c2.002 0 3.08-1.64 3.08-3.68Zm-8.4 1.88c-.998 0-1.8-.802-1.8-1.8s.802-1.8 1.8-1.8 1.8.802 1.8 1.8-.802 1.8-1.8 1.8Zm6-5.4h-12v-6h12v6Z",
    fill: "#949191"
  })));
};

export default SvgIconTram;